/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Cookies from 'js-cookie';
import { formatNumber } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/phone-number.js';
export const updateDynamicLinks = (linkURL, campaignObj, endpoint) => {
    const referralData = ['421903', '421904', 'OSYIFP', '421905', '421906'];
    const campaignMedium = campaignObj['campaignMedium-cipublic'];
    const campaignSource = campaignObj['campaignSource-cipublic'];
    const campaignPhone = campaignObj['campaignPhone-cipublic'];
    const campaignPID = campaignObj['campaignPID-cipublic'];
    const campaignEID = campaignObj['campaignEID-cipublic'];
    const csbSuppCampaign = campaignObj['csbSuppCampaign-cipublic'];
    const ifpDenCampaign = campaignObj['ifpDenCampaign-cipublic'];
    const ifpMedCampaign = campaignObj['ifpMedCampaign-cipublic'];
    const campaignzipCode = Cookies.get('campaignZipCode-cipublic');
    const addPID = campaignPID && !referralData.includes(campaignPID) ? `&PID=${campaignPID}` : '';
    const addEID = campaignEID && !referralData.includes(campaignEID) ? `&EID=${campaignEID}` : '';
    const addZip = campaignzipCode && campaignzipCode.length ? `&zip_code=${campaignzipCode}` : '';
    let linkChangeResult = '';
    const linkList = {
        quoteSupplemental: {
            linkToFind: ['cignasupplemental.expressenroll.com'],
            linkParams: `cid=s037&campaign_id=${csbSuppCampaign}`,
            linkReplace: 'https://cignasupplemental.expressenroll.com/',
        },
        quoteDental: {
            linkToFind: ['cignadental.com/equotes/startInterview.action'],
            // Temporary fix (hardcode IFP_SAD) post redesign launch, investigate if we need to change DRTDEN in campaign api service????
            // linkParams: `link_case=quote&campaign_id=${ifpDenCampaign}&call=${formatNumber(campaignPhone, '.')}${addPID}`,
            linkParams: `link_case=quote&campaign_ID=IFP_SAD&utm_campaign=${ifpDenCampaign}${addPID}`,
            linkReplace: `${endpoint}`,
        },
        quoteMedical: {
            linkToFind: ['cignaindividual.com/public-ede'],
            linkParams: `utm_source=${campaignSource}&utm_medium=${campaignMedium}&utm_campaign=${ifpMedCampaign}&campaign_ID=${ifpMedCampaign}&call=${formatNumber(campaignPhone, '.')}&_agent_id=cigna${addPID}${addEID}${addZip}`,
            linkReplace: 'https://cignaindividual.com/public-ede/',
        },
        quoteMedHealthSherpa: {
            linkToFind: ['cigna.healthsherpa.com'],
            linkParams: `utm_source=${campaignSource}&utm_medium=${campaignMedium}&utm_campaign=${ifpMedCampaign}&campaign_ID=${ifpMedCampaign}&call=${formatNumber(campaignPhone, '.')}&_agent_id=cigna${addPID}${addEID}${addZip}`,
            linkReplace: 'https://cigna.healthsherpa.com/',
        },
        quoteMedShopCigna: {
            linkToFind: ['shopcigna.com'],
            linkParams: `utm_source=${campaignSource}&utm_medium=${campaignMedium}&utm_campaign=${ifpMedCampaign}&campaign_ID=${ifpMedCampaign}&call=${formatNumber(campaignPhone, '.')}&_agent_id=cigna${addPID}${addEID}${addZip}`,
            linkReplace: 'https://shopcigna.com/',
        },
        quoteMedicare: {
            linkToFind: ['cignasupplemental.com/equotes/startInterview.action'],
            linkParams: `cid=s037&campaign_ID=${csbSuppCampaign}${addZip}`,
            linkReplace: 'https://cignasupplemental.com/equotes/startInterview.action',
        },
    };
    Object.keys(linkList).forEach((key) => {
        if (linkList[key].linkToFind.some((link) => linkURL.includes(link))) {
            linkChangeResult = `${linkList[key].linkReplace}?${linkList[key].linkParams}`;
        }
    });
    return linkChangeResult;
};
//# sourceMappingURL=service.js.map